import React from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  InputAdornment,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Divider,
  TableContainer,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { IReferralDetail } from "../../../services/affiliate";

interface WalletHistoryProps {
  referrals: IReferralDetail[];
}

const WalletHistory = ({ referrals }: WalletHistoryProps) => {
  const formatDateTime = (dateString: string) => {
    const date = new Date(dateString);
    return {
      date: date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      }),
      time: date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }),
    };
  };

  const formatAmount = (amount: number) => {
    return `${amount.toLocaleString()} NGN`;
  };

  const walletHistory = referrals.map((referral) => {
    const { date, time } = formatDateTime(referral.transactionDate);
    return {
      date,
      time,
      amount: formatAmount(referral.amountEarned),
      type: `${
        referral.type.charAt(0).toUpperCase() + referral.type.slice(1)
      } Referral`,
    };
  });

  return (
    <Box sx={{ px: { xs: 1.5, sm: 3 }, py: 3 }}>
      <Typography
        variant="h6"
        fontWeight="bold"
        gutterBottom
        sx={{ color: "#333", mb: 3 }}
      >
        Wallet History
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <TextField
          placeholder="Search here..."
          variant="outlined"
          size="small"
          sx={{ width: "300px" }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            sx: {
              borderRadius: "8px",
            },
          }}
        />
        {/* <Box>
          <Button
            variant="outlined"
            startIcon={<FilterListIcon />}
            sx={{ mr: 2, borderColor: "#344054", color: "#344054" }}
          >
            Filter
          </Button>
          <Button
            sx={{ mr: 2, borderColor: "#344054", color: "#344054" }}
            variant="outlined"
            startIcon={<CalendarTodayIcon />}
          >
            Select dates
          </Button>
        </Box> */}
      </Box>
      <Paper elevation={0} sx={{ maxWidth: "100%" }}>
        <TableContainer sx={{ maxWidth: "100%", overflowX: "auto" }}>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#F0F2F5",
                  borderBottom: "1px solid #E4E7EC",
                }}
              >
                <TableCell sx={{ py: 1.5 }}>Date</TableCell>
                <TableCell sx={{ py: 1.5 }}>Amount</TableCell>
                <TableCell sx={{ py: 1.5 }}>Type</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {walletHistory.length > 0 ? (
                walletHistory.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {row.date}
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ mx: 1 }}
                        />
                        <Typography variant="caption" color="text.secondary">
                          {row.time}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ color: "#379E66" }}>
                      {row.amount}
                    </TableCell>
                    <TableCell>{row.type}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center" sx={{ py: 3 }}>
                    No wallet history available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default WalletHistory;
